const validate = values => {
	const errors = {}
	if (!values.winecellar_name) {
		errors.winecellar_name = 'Este Campo es Obligatorio'
	}
	if (!values.winecellar_number_institution) {
		errors.winecellar_number_institution = 'Este Campo es Obligatorio'
	}
	if (!values.winecellar_address) {
		errors.winecellar_address = 'Este Campo es Obligatorio'
	}
	if (!values.winecellar_cuil) {
		errors.winecellar_cuil = 'Este Campo es Obligatorio'
	}
	if (!values.winecellar_area_code) {
		errors.winecellar_area_code = 'Este Campo es Obligatorio'
	}
	if (!values.winecellar_number) {
		errors.winecellar_number = 'Este Campo es Obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsWinecellarForm.js
 **/